import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { replace } from 'redux-first-history';

import * as orderActions from '../../../actions/order';
import { getCurrentLocation } from '../../../sagas/selectors';
import { deleteSearchParam } from '../../../utils/historyUtils';

import Button from '../../Button';
import ButtonsRow from '../../ButtonsRow/ButtonsRow';
import Modal from '../../Modal';

import './CustomMenuModal.css';

function CustomMenuModal({ isModalOpen, hideModal }) {
  const dispatch = useDispatch();
  const { pathname, search } = useSelector(getCurrentLocation);

  const onPullCustomMenuClick = () => {
    hideModal();
    dispatch(orderActions.getCustomMenu());
  };

  const onHideModalClick = () => {
    hideModal();
    dispatch(replace({ pathname, search: deleteSearchParam(search, 'customMenu') }));
  };
  return (
    <Modal className="CustomMenuModal" show={isModalOpen}>
      <div className="modal-control" />
      <Modal.Body className="kale">
        <Typography className="custom-menu-title" variant="calafia2" color="primary.dark">
          Hold up!
        </Typography>
        <p>
          You have some items in your cart, and you&apos;re trying to add new custom menu items. We
          need to clear your cart to do this.
        </p>
        <ButtonsRow>
          <Button className="btn-primary" onClick={onPullCustomMenuClick}>
            Clear cart and add items
          </Button>
          <Button className="btn-primary" onClick={onHideModalClick}>
            No, keep my cart
          </Button>
        </ButtonsRow>
      </Modal.Body>
    </Modal>
  );
}

CustomMenuModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default CustomMenuModal;
